/**
 * Playlist Search Page Utilities
 *
 * Date/time formatting and helper functions for the playlist search feature.
 */

/**
 * Format ISO date string to German locale date (DD.MM.YYYY)
 */
export function formatDate(isoDate: string): string {
  const date = new Date(isoDate);
  return date.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

/**
 * Format ISO date string to German locale time (HH:MM)
 */
export function formatTime(isoDate: string): string {
  const date = new Date(isoDate);
  return date.toLocaleTimeString("de-DE", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * Get today's date in ISO format (YYYY-MM-DD)
 */
export function getTodayDate(): string {
  return new Date().toISOString().split("T")[0];
}

/**
 * Get current time in HH:MM format
 */
export function getCurrentTime(): string {
  return new Date().toTimeString().slice(0, 5);
}

/**
 * Combine date and time strings into an ISO timestamp
 */
export function combineDateTimeToISO(date: string, time: string): string {
  return new Date(`${date}T${time}:00`).toISOString();
}
